<template>
  <div class="main">
    <el-container class="main-box">
      <!-- 顶栏 -->
      <el-header
        id="header"
        style="height: auto; position: absolute; top: 28px"
      >
        <YHeader class="header"></YHeader>
      </el-header>
      <!-- 内容区域 -->
      <el-main class="container" style="background: #fff; padding: 0">
        <router-view></router-view>
      </el-main>
      <!-- 底栏 -->
      <el-footer class="floorfooter">
        <YFooter class="footer"></YFooter>
      </el-footer>
    </el-container>
    <div
      style="
        background: rgb(32, 45, 66);
        height: 110px;
        display: flex;
        justify-content: space-evenly;
        flex-wrap: wrap;
        align-content: space-around;
      "
    >
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        style="color: #808795"
        >鲁ICP备16046324号-1</a
      >
      <p style="color: #808795">开发者：百舜信息技术有限公司</p>
    </div>
  </div>
</template>

<script>
//引入外部组件
import { YHeader, YFooter } from '@/components'
export default {
  name: 'YedeerLayout',
  components: { YHeader, YFooter }
}
</script>

<style lang="less" scoped>
.main {
  min-height: 100vh;
  height: 100%;
  width: 100%;
  margin: 0 auto;
  // max-width: 1440px;
  position: relative;
}

.main-box {
  position: relative;
  height: auto;
}

#header {
  position: absolute;
  top: 28px;
  left: 50%;
  transform: translateX(-50%);
}

.header {
  max-width: 1172px;
  min-width: 1172px;
  // background-color: #fff;
  margin: 0 auto;
  height: auto;
  min-height: 52px;
  max-height: 52px;
}

.floorfooter {
  // background:#fff;
  // background:pink;
  padding-bottom: 359px;
  height: auto;
  // max-height: 359px;
  max-height: 450px;
  position: absolute;
  bottom: 0;
  left: 50%;
  overflow: hidden;
  transform: translateX(-50%);
}

.footer {
  // max-width: 1172px;
  overflow: hidden;
  // background-color: rgb(176, 56, 56);
  margin: 0 auto;
}

.container {
  width: 100%;
  margin: 0 auto;
  // height: ;
}
</style>
